import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  headersDenominacaoGenerica,
  fieldObjectDenominacaoGenerica as fieldObject,
  valoresExibidosDenominacoes as valoresExibidos,
} from './auxiliarDenominacoesGenericas';
import BarraInferiorBotoes from '../../../../components/BarraInferiorBotoes';
import BarraSubAbas from '../../../../components/BarraSubAbas';
import BoxConteudo from '../../../../components/BoxConteudo';
//import Button from '../../../../components/Button';
import ContainerConteudo from '../../../../components/ContainerConteudo';
import CustomButton from '../../../../components/CustomButton';
import CustomCol from '../../../../components/CustomCol';
import CustomRow from '../../../../components/CustomRow';
import CustomSpan from '../../../../components/CustomSpan';
import Input from '../../../../components/InputNew';
import Select from '../../../../components/InputNew/Select';
import Tabela from '../../../../components/Tabela';
import WorkspaceBotoes from '../../../../components/WorkspaceBotoes';
import BolinhaTabelaStatus from '../../../../components/bolinhaTabelaStatus';
import {
  getUser,
  isActionAllowed,
} from '../../../../modules/contexts/Auth/RequireAuth';
import { useModuloUsuario } from '../../../../services/enum/useModuloUsuario';
import { usePapelUsuario } from '../../../../services/enum/usePapelUsuario';
import { useTipoProduto } from '../../../../services/enum/useTipoProduto';
import { getAllDenominacoesGenericas } from '../../../../services/produtosDAF/denominacoesGenericasService';
import { ENTITY } from '../../../../utils/entityNames';
import {
  ExportToExcel,
  formataNomeMeioSiglas,
  formatDate,
} from '../../../../utils/functions';
import SubAbas from '../subabas';

//DADOS USUARIO
const user = getUser();
const userID = user.sub;
const entity = ENTITY.ENTITY_DenominacaoGenerica;

const DenominacoesIndex: React.FC = () => {
  const CACHE_KEY = 'cachedDenominacoes';
  const CACHE_EXPIRATION = 60 * 60 * 1000;
  //PERMISSOES
  const papelUsuarioOptions = usePapelUsuario();
  const moduloUsuarioOptions = useModuloUsuario();
  // Obter o módulo
  const MODULO = Number(
    moduloUsuarioOptions.find(
      (modulo) => modulo.label === 'Denominações Genéricas',
    )?.value || '0',
  );

  // Verificar permissões para ações
  const canDownload = isActionAllowed(MODULO, 'read', papelUsuarioOptions);
  const canInsert = isActionAllowed(MODULO, 'create', papelUsuarioOptions);
  //PERMISSOES

  const navigate = useNavigate();
  const tipoProduto = useTipoProduto();

  //Dados do componente
  const [formFiltros, setFormFiltros] = useState({
    tipoProduto: 0,
    dcb: '',
    denominacaoGenerica: '',
  });
  const [data, setData] = useState<any[]>([]);

  const fetchData = async () => {
    try {
      const cachedData = localStorage.getItem(CACHE_KEY);
      const now = new Date().getTime();

      // Verifica se há cache válido
      if (cachedData) {
        const { timestamp, data } = JSON.parse(cachedData);
        const timeDifference = now - timestamp;

        if (timeDifference < CACHE_EXPIRATION) {
          setData(data); // Usa os dados do cache sem buscar na API
          return;
        } else {
          localStorage.removeItem(CACHE_KEY);
        }
      }

      // Busca da API apenas se não houver cache ou se estiver expirado
      const registros = await getAllDenominacoesGenericas();
      setData(registros);

      localStorage.setItem(
        CACHE_KEY,
        JSON.stringify({ timestamp: now, data: registros }),
      );
    } catch (error) {
      console.error('❌ Erro ao obter dados:', error);
    }
  };

  // Chama o fetchData no primeiro render
  useEffect(() => {
    fetchData();
  }, []);

  //Dados da tabela
  const tableData = data
    .map((item) => ({
      id: item.id,
      tipoProduto: tipoProduto[item.tipoProduto]?.label || 'Não informado',
      dcb: item.dcb,
      compBasico: <BolinhaTabelaStatus status={item.compBasico} />,
      compEspecializado: (
        <BolinhaTabelaStatus status={item.compEspecializado} />
      ),
      compEstrategico: <BolinhaTabelaStatus status={item.compEstrategico} />,
      denominacaoGenerica: item.denominacaoGenerica,
    }))
    .filter((item: any) => {
      return (
        (formFiltros.tipoProduto === 0 ||
          item.tipoProduto === tipoProduto[formFiltros.tipoProduto]?.label) &&
        (formFiltros.dcb === '' ||
          item.dcb.toLowerCase().includes(formFiltros.dcb.toLowerCase())) &&
        (formFiltros.denominacaoGenerica === '' ||
          item.denominacaoGenerica
            .toLowerCase()
            .includes(formFiltros.denominacaoGenerica.toLowerCase()))
      );
    });

  //Dados do Offcanvas
  const offCanvasData = data.map((item) => ({
    id: item.id,
    dataRegistro:
      formatDate(item.dataRegistro) +
      ' - ' +
      formataNomeMeioSiglas(item.usuarioRegistro.nomeCompleto),
    dataUltimaAtualizacao:
      formatDate(item.dataUltimaAtualizacao) +
      ' - ' +
      formataNomeMeioSiglas(item.usuarioAtualizacao.nomeCompleto),

    dataUltimaVisualizacao:
      formatDate(item.dataUltimaVisualizacao) +
      ' - ' +
      formataNomeMeioSiglas(item.usuarioUltimaVisualizacao.nomeCompleto),
    nEdicoes: item.nEdicoes,
    nVisualizacoes: item.nVisualizacoes,
    separadorLog: '',
    denominacaoGenerica: <b>{item.denominacaoGenerica}</b>,
    tipoProduto: tipoProduto[item.tipoProduto]?.label || 'Não informado',
    dcb: item.dcb,
    compBasico:
      item.compBasico === 'S' ? (
        <CustomSpan texto="Sim" />
      ) : (
        <CustomSpan texto="Não" />
      ),
    compEspecializado:
      item.compEspecializado === 'S' ? (
        <CustomSpan texto="Sim" />
      ) : (
        <CustomSpan texto="Não" />
      ),
    compEstrategico:
      item.compEstrategico === 'S' ? (
        <CustomSpan texto="Sim" />
      ) : (
        <CustomSpan texto="Não" />
      ),
    separadorObservacoes: '',
    observacoes: item.observacoes,
  }));

  // Funções Handle
  const handleClearFiltros = () => {
    setFormFiltros({
      ...formFiltros,
      tipoProduto: 0,
      dcb: '',
      denominacaoGenerica: '',
    });
  };

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    if (name === 'tipoProduto') {
      const newValue = parseInt(value, 10);
      setFormFiltros({
        ...formFiltros,
        tipoProduto: newValue,
      });
    } else {
      setFormFiltros((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleClickInserir = () => {
    navigate('ficha/dadosgerais');
  };

  interface ExportData {
    id: number;
    dataRegistro: string;
    usuarioRegistro: {
      nomeCompleto: string;
    };
    dataUltimaAtualizacao: string;
    usuarioAtualizacao: {
      nomeCompleto: string;
    };
    dataUltimaVisualizacao: string;
    usuarioUltimaVisualizacao: {
      nomeCompleto: string;
    };
    nEdicoes: number;
    nVisualizacoes: number;
    nVisualizadores: number;

    //Específicos
    tipoProduto: number;
    denominacaoGenerica: string;
    dcb: string;

    //Observações
    observacoes: string;
  }

  const prepareDataForExport = (data: ExportData[]) => {
    return data.map((item) => {
      return {
        id: item.id,

        //Logs
        dataRegistro: item.dataRegistro,
        usuarioRegistro: item.usuarioRegistro.nomeCompleto,
        dataUltimaAtualizacao: item.dataUltimaAtualizacao,
        usuarioAtualizacao: item.usuarioAtualizacao.nomeCompleto,
        dataUltimaVisualizacao: item.dataUltimaVisualizacao,
        usuarioUltimaVisualizacao: item.usuarioUltimaVisualizacao.nomeCompleto,
        nEdicoes: item.nEdicoes,
        nVisualizacoes: item.nVisualizacoes,
        nVisualizadores: item.nVisualizadores,

        //Específicos
        tipoProduto: tipoProduto[item.tipoProduto].label,
        denominacaoGenerica: item.denominacaoGenerica,
        dcb: item.dcb,

        //Observações
        observacoes: item.observacoes,
      };
    });
  };

  const filteredDataForExport = data.filter((item) => {
    return (
      (formFiltros.tipoProduto === 0 ||
        item.tipoProduto === tipoProduto[formFiltros.tipoProduto].label) &&
      (formFiltros.dcb === '' ||
        item.dcb.toLowerCase().includes(formFiltros.dcb.toLowerCase())) &&
      (formFiltros.denominacaoGenerica === '' ||
        item.denominacaoGenerica
          .toLowerCase()
          .includes(formFiltros.denominacaoGenerica.toLowerCase()))
    );
  });

  return (
    <>
      <BarraSubAbas subAbas={SubAbas} />

      <ContainerConteudo>
        <BoxConteudo boxTitulo="Filtros">
          <CustomRow style={{ marginTop: '-15px' }}>
            <CustomCol width="15%">
              <Select
                name="tipoProduto"
                value={formFiltros.tipoProduto}
                options={tipoProduto}
                onChange={handleChange}
                label="Tipo de Produto"
              />
            </CustomCol>
            <CustomCol width="10%">
              <Input
                id="dcb"
                name="dcb"
                value={formFiltros.dcb}
                label="DCB"
                onChange={handleChange}
              />
            </CustomCol>
            <CustomCol width="75%">
              <Input
                id="denominacaoGenerica"
                name="denominacaoGenerica"
                value={formFiltros.denominacaoGenerica}
                label="Denominação Genérica"
                onChange={handleChange}
              />
            </CustomCol>
          </CustomRow>
          <CustomRow style={{ marginTop: '-15px', textAlign: 'right' }}>
            <CustomCol className="mt-3 justify-content-end align-content-end">
              <CustomButton
                label="Limpar filtros"
                bgColor="#808080" // Cor cinza
                textColor="#ffffff" // Texto branco
                onClick={handleClearFiltros}
              />
            </CustomCol>
          </CustomRow>
        </BoxConteudo>

        <Tabela
          headers={headersDenominacaoGenerica}
          dataTable={tableData}
          dataOffCanvas={offCanvasData}
          displayValues={valoresExibidos}
          tituloCanvas="DENOMINAÇÃO GENÉRICA"
        />
      </ContainerConteudo>

      <BarraInferiorBotoes>
        <WorkspaceBotoes
          download
          downloadDisabled={!canDownload}
          onClickDownload={() =>
            ExportToExcel(
              prepareDataForExport(filteredDataForExport),
              valoresExibidos,
              fieldObject,
              'sisaf_denominacoes_genericas.xlsx',
              userID,
              'DAF', // Nome da interface
              entity, // Nome da entidade
            )
          }
          inserir
          inserirDisabled={!canInsert}
          onClickInserir={handleClickInserir}
        />
      </BarraInferiorBotoes>
    </>
  );
};

export default DenominacoesIndex;
